import React, { createContext, useState } from "react";

const VendaRapidaContext = createContext();

const VendaRapidaContextProvider = ({ children }) => {
  //VendaRapida
  // Vendedor
  const [sellerCodeAux, setSellerCodeAux] = useState("");
  const [sellerCode, setSellerCode] = useState("");
  const [sellerName, setSellerName] = useState("");
  const [sellerErrors, setSellerErrors] = useState({});
  const [sellerCpfCnpj, setSellerCpfCnpj] = useState("");
  const [sellerComission, setSellerComission] = useState("0,00");
  const [sellerInfos, setSellerInfos] = useState(null);

  // Cliente
  const [clientInfos, setClientInfos] = useState(null);
  const [clientCpf, setClientCpf] = useState("");
  const [clientCpfAux, setClientCpfAux] = useState("");
  const [clientName, setClientName] = useState("VENDA CONSUMIDOR");
  const [clientErrors, setClientErrors] = useState({});
  const [clientId, setClientId] = useState(1);

  // Produto
  const [productInfos, setProductInfos] = useState(null);
  const [productCode, setProductCode] = useState("");
  const [productStorageCode, setProductStorageCode] = useState("");
  const [productCodeAux, setProductCodeAux] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productPrice, setProductPrice] = useState("0,00");
  const [productQuantity, setProductQuantity] = useState(1);
  const [productImage, setProductImage] = useState("");
  const [productDiscount, setProductDiscount] = useState("0,00");
  const [productUnity, setProductUnity] = useState("");
  const [productErrors, setProductErrors] = useState({});
  const [productConversionFactor, setProductConversionFactor] =
    useState("0,00000");
  const [productBruteCost, setProductBruteCost] = useState("0,00");

  const [updatedValue, setUpdatedValue] = useState("0,00");
  const [disabledAddButton, setDisabledAddButton] = useState(true);
  const [itemsDiscount, setItemsDiscount] = useState("0,00");
  const [totalDiscountView, setTotalDiscountView] = useState("0,00");

  // Usuario
  const [userMaximumDiscountPercentage, setUserMaximumDiscountPercentage] =
    useState("0,00");

  //Table
  const [tableRows, setTableRows] = useState([]);
  const [orderTotal, setOrderTotal] = useState("0,00");
  const [orderTotalNoDiscount, setOrderTotalNoDiscount] = useState("0,00");

  //Modal
  const [modalFinishOpen, setModalFinishOpen] = useState(false);

  //ModalVRFReceber
  //Pagamento
  const [onTotalDiscount, setOnTotalDiscount] = useState("0,00");
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [bankAccountsList, setBankAccountsList] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [paymentValue, setPaymentValue] = useState("0,00");
  const [toPayValue, setToPayValue] = useState("0,00");
  const [isPercentage, setIsPercentage] = useState(false);
  const [totalPayment, setTotalPayment] = useState("0,00");
  const [troco, setTroco] = useState("0,00");
  const [paymentRows, setPaymentRows] = useState([]);
  const [paymentTotal, setPaymentTotal] = useState("0,00");
  const [paymentErrors, setPaymentErrors] = useState({});
  const [modalVrfLoading, setModalVrfLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);

  //Dialog selecionar caixa
  const [dialogSelectCaixaOpen, setDialogSelectCaixaOpen] = useState(false);
  const [selectedCaixa, setSelectedCaixa] = useState(null);

  //Modal de autenticar usuário
  const [modalAuthenticateOpen, setModalAuthenticateOpen] = useState(false);
  const [modalAuthenticateWarnings, setModalAuthenticateWarnings] = useState(
    []
  );

  //Modal cheque e cartão
  const [modalChequeCartaoOpen, setModalChequeCartaoOpen] = useState(false);
  const [editRowCheckOrCard, setEditRowCheckOrCard] = useState(null);

  // cartao
  const [cardAuthorizationNumber, setCardAuthorizationNumber] = useState("");
  const [cardDocnsu, setCardDocnsu] = useState("");
  const [cardSelectedBandeira, setCardSelectedBandeira] = useState(null);
  const [cardSelectedOperadora, setCardSelectedOperadora] = useState(null);
  const [cardErrors, setCardErrors] = useState({});

  const [cardBandeirasList, setCardBandeirasList] = useState([]);
  const [cardOperadorasList, setCardOperadorasList] = useState([]);

  // cheque
  const [checkErrors, setCheckErrors] = useState({});
  const [isCheck, setIsCheck] = useState(false);

  const [checkBanda, setCheckBanda] = useState("");
  const [checkNumber, setCheckNumber] = useState("");
  const [checkDepositDate, setCheckDepositDate] = useState("");
  const [checkCpfCnpj, setCheckCpfCnpj] = useState("");
  const [checkBankCode, setCheckBankCode] = useState("");
  const [checkAgency, setCheckAgency] = useState("");
  const [checkCurrentAccount, setCheckCurrentAccount] = useState("");
  const [checkAccountHolder, setCheckAccountHolder] = useState("");

  //Finalização da venda
  const [buttonNewOrderView, setButtonNewOrderView] = useState(false);
  const [storedOrderCode, setStoredOrderCode] = useState(null);
  const [generalDiscount, setGeneralDiscount] = useState("0,00");

  const [finishButtonView, setFinishButtonView] = useState(true);
  const [displayNoneTransmit, setDisplayNoneTransmit] = useState(false);

  const [disabledPaymentActions, setDisabledPaymentActions] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  return (
    <VendaRapidaContext.Provider
      value={{
        sellerCode,
        sellerCpfCnpj,
        setSellerCpfCnpj,
        setSellerCode,
        sellerName,
        setSellerName,
        clientId,
        setClientId,
        clientCpf,
        setClientCpf,
        clientName,
        setClientName,
        productCode,
        setProductCode,
        productDescription,
        setProductDescription,
        productPrice,
        setProductPrice,
        productConversionFactor,
        setProductConversionFactor,
        tableRows,
        setTableRows,
        productQuantity,
        setProductQuantity,
        orderTotal,
        setOrderTotal,
        orderTotalNoDiscount,
        setOrderTotalNoDiscount,
        updatedValue,
        setUpdatedValue,
        productDiscount,
        setProductDiscount,
        productBruteCost,
        setProductBruteCost,
        disabledAddButton,
        setDisabledAddButton,
        onTotalDiscount,
        setOnTotalDiscount,
        selectedPaymentType,
        setSelectedPaymentType,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        selectedBankAccount,
        setSelectedBankAccount,
        bankAccountsList,
        setBankAccountsList,
        bankAccounts,
        setBankAccounts,
        toPayValue,
        setToPayValue,
        sellerComission,
        setSellerComission,
        isPercentage,
        setIsPercentage,
        modalFinishOpen,
        setModalFinishOpen,
        sellerErrors,
        setSellerErrors,
        clientErrors,
        setClientErrors,
        productErrors,
        setProductErrors,
        paymentValue,
        setPaymentValue,
        totalPayment,
        setTotalPayment,
        troco,
        setTroco,
        paymentRows,
        setPaymentRows,
        paymentTotal,
        setPaymentTotal,
        productImage,
        setProductImage,
        paymentErrors,
        setPaymentErrors,
        modalVrfLoading,
        setModalVrfLoading,
        productCodeAux,
        setProductCodeAux,
        productStorageCode,
        setProductStorageCode,
        modalChequeCartaoOpen,
        setModalChequeCartaoOpen,
        buttonNewOrderView,
        setButtonNewOrderView,
        storedOrderCode,
        setStoredOrderCode,
        displayNoneTransmit,
        setDisplayNoneTransmit,
        finishButtonView,
        setFinishButtonView,
        disabledPaymentActions,
        setDisabledPaymentActions,
        paymentMethods,
        setPaymentMethods,
        generalDiscount,
        setGeneralDiscount,
        paymentTypes,
        setPaymentTypes,
        itemsDiscount,
        setItemsDiscount,
        totalDiscountView,
        setTotalDiscountView,
        productUnity,
        setProductUnity,
        cardOperadorasList,
        setCardOperadorasList,
        cardBandeirasList,
        setCardBandeirasList,
        cardSelectedBandeira,
        setCardSelectedBandeira,
        cardSelectedOperadora,
        setCardSelectedOperadora,
        cardDocnsu,
        setCardDocnsu,
        cardAuthorizationNumber,
        setCardAuthorizationNumber,
        cardErrors,
        setCardErrors,
        checkErrors,
        setCheckErrors,
        isCheck,
        setIsCheck,
        checkBanda,
        setCheckBanda,
        checkNumber,
        setCheckNumber,
        checkDepositDate,
        setCheckDepositDate,
        checkCpfCnpj,
        setCheckCpfCnpj,
        checkBankCode,
        setCheckBankCode,
        checkAgency,
        setCheckAgency,
        checkCurrentAccount,
        setCheckCurrentAccount,
        checkAccountHolder,
        setCheckAccountHolder,
        editRowCheckOrCard,
        setEditRowCheckOrCard,
        dialogSelectCaixaOpen,
        setDialogSelectCaixaOpen,
        selectedCaixa,
        setSelectedCaixa,
        sellerInfos,
        setSellerInfos,
        sellerCodeAux,
        setSellerCodeAux,
        productInfos,
        setProductInfos,
        clientInfos,
        setClientInfos,
        clientCpfAux,
        setClientCpfAux,

        isLoading,
        setIsLoading,

        modalAuthenticateOpen,
        setModalAuthenticateOpen,
        modalAuthenticateWarnings,
        setModalAuthenticateWarnings,

        userMaximumDiscountPercentage,
        setUserMaximumDiscountPercentage,
      }}
    >
      {children}
    </VendaRapidaContext.Provider>
  );
};

export { VendaRapidaContextProvider, VendaRapidaContext };
